import BetaLabel from '@anm/components/BetaLabel';
import Tooltip from '@anm/components/Tooltip';
import { ButtonVariants } from '@anm/components/buttons/Button';
import noop from '@anm/helpers/noop';
import { FC } from 'react';

import { ButtonWrapper, Wrapper } from './Wrapper';

type NewStreamButtonProps = {
  iconName: string;
  onClick: () => void;
  text?: string;
  variant?: ButtonVariants;
  isPending?: boolean;
  showBetaLabel?: boolean;
  tooltipDelayHide?: number;
  tooltipDelayShow?: number;
  isStreamButtonDisabled?: boolean;
  renderTooltip?(): JSX.Element;
};

const NewStreamButton: FC<NewStreamButtonProps> = ({
  onClick,
  iconName,
  variant = 'red',
  text = 'New stream',
  isPending,
  renderTooltip,
  tooltipDelayHide = 300,
  tooltipDelayShow = 300,
  showBetaLabel = false,
  isStreamButtonDisabled = false
}) => (
  <Wrapper>
    <Tooltip
      withArrow
      variant="black"
      direction="to-bottom"
      delayShow={tooltipDelayShow}
      delayHide={tooltipDelayHide}
      renderContent={renderTooltip}
    >
      <ButtonWrapper
        size="big"
        {...{ variant }}
        icon={`images/icons/${iconName}.svg`}
        isDisabled={isStreamButtonDisabled}
        isPending={isPending}
        onClick={isStreamButtonDisabled ? noop : onClick}
      >
        {text}
      </ButtonWrapper>
      {showBetaLabel && <BetaLabel positionVariant="top-right" />}
    </Tooltip>
  </Wrapper>
);

export default NewStreamButton;
